module.exports = __webpack_public_path__ + "static/img/fdmPurpose2.d316c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fdmPurpose2.png
// module id = yfYh
// module chunks = 2